export interface ChannelChangeState {
  channelNumber: number[];
  channelId: number;
  showChannelChange: boolean;
  source: string;
  offset: number;
}

export const enum ChannelChangeAction {
  UpdateChannelNumber = "UpdateChannelNumber",
  UpdateChannelChange = "UpdateChannelChange",
  UpdateSource = "SetSource",
  UpdateOffset = "SetOffset",
  UpdateChannel = "UpdateChannel"
}

export const enum ChannelChangeMutation {
  SetChannelNumber = "SetChannelNumber",
  ClearChannelNumber = "ClearChannelNumber",
  SetChannelChange = "SetChannelChange",
  SetSource = "SetSource",
  SetOffset = "SetOffset",
  SetChannelId = "SetChannelId"
}

export const enum ChannelChangeGetter {
  GetChannelNumber = "GetChannelNumber",
  GetChannelChange = "GetChannelChange",
  GetSource = "GetSource",
  GetOffset = "GetOffset",
  GetChannelId = "GetChannelId"
}

export const enum ChannelDirection {
  ChannelUp = "ChannelUp",
  ChannelDown = "ChannelDown"
}
